// CANONICAL COPY (GH #7115). src/constants/obligations/obl-cra-secure-update-distribution.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

module.exports = {
  id: 'obl-cra-secure-update-distribution',
  title: 'Distribute security updates securely, without delay and free of charge',
  description:
    'Confirm that the manufacturer provides mechanisms to securely distribute updates for products with digital elements so that vulnerabilities are fixed or mitigated in a timely manner and, where applicable, in an automatic manner (CRA Annex I, Part II §7). Security patches and updates are disseminated without delay and, unless otherwise agreed for tailor-made products, free of charge, accompanied by advisory messages that provide users with the information necessary to act, including potential action to be taken (CRA Art. 13(10), 13(15) and Annex I, Part II §8). Security updates are issued separately from functional updates where technically feasible. Review the update-distribution architecture, the integrity controls (signing, channel security), the advisory template, and the delivery record.',
  category: 'technical',
  scfIds: ['SCF-OPS-005', 'SCF-DEV-008', 'SCF-NET-005'],
  cadence: { frequency: '3m', anchor: 'domain' },
  strategy: 'all',
  fulfilmentCriteria: [
    {
      type: 'document-published',
      description: 'Secure update distribution procedure is published',
    },
    { type: 'document-approved', description: 'Procedure has been approved' },
    { type: 'document-within-sla', description: 'Procedure review is not overdue' },
  ],
  domainActions: [{ type: 'approve-document', label: 'Approve Document' }],
};
